import axiosInstance from '../common/axios-config'

export const GetPassportData = async (keys) => {
  const queryKeys = keys.queryKey
  const {data} = await axiosInstance.get(`/api/v1/Assets/${queryKeys[1]}/Passport/`)
  return data
}